module.exports = __webpack_public_path__ + "e6.no2.c4ddc060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e6.no2.jpg
// module id = Je2a
// module chunks = 0